export const TYPE_REGULAR_FEE = "fee"
export const TYPE_LATE_FEE = "late-fee"


// WEBPACK FOOTER //
// ./src/state/fee/feeTypes.ts